const initVideo = () => {
  const container = document.querySelector('[data-video-container]');
  const video = container?.querySelector('video');
  const playBtn = container?.querySelector('[data-play-btn]');

  if (!video || !playBtn) return;

  let isPlaying = false;

  const update = () => {
    isPlaying = !video.paused;
    
    const showControls = isPlaying || (!video.paused && !video.ended);
    
    video.controls = showControls;
    playBtn.classList.toggle('is-hidden', isPlaying);
    container.classList.toggle('is-playing', isPlaying);
  };

  const toggle = () => (video.paused ? video.play() : video.pause());

  [playBtn, video].forEach((el) => el.addEventListener('click', toggle));

  ['play', 'pause', 'ended', 'loadedmetadata'].forEach((event) =>
    video.addEventListener(event, update)
  );
  

  update();
};

export { initVideo };